// Expense.js (Updated for edit navigation + frontend-only filtering + date desc sort)
import React, { useState, useRef, useEffect, useCallback } from "react";
import Navbar from "components/Navbars/AuthNavbar";
import Footer from "components/Footers/Footer";
import BASE_URL from "components/BaseUrl/apiConfig";
import Swal from "sweetalert2";
import "react-block-ui/style.css";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import "components/Expense/style.css";
import { DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import BlockUiOverlay from "./BlockUiOverlay";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { ChevronDown, Filter, SlidersHorizontal, ChevronUp, Plus, MoveRight, Pencil, Trash2, MoveLeft } from "lucide-react";
import DatePicker from "react-datepicker";
import { Link } from "react-router-dom";
import ExpenseChatbot from "components/Chatbot/ExpenseChatbot";


const Expense = () => {
  const [isChecked, setIsChecked] = useState(false);
  const history = useHistory();
  const userNameInputRef = useRef(null);
  const dropdownRef = useRef(null);
  const [currency, setCurrency] = useState("");
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [monthName, setMonthName] = useState(null);
  const [expenseData, setExpenseData] = useState({
    expenseDescritions: [],
    expenses: [],
    TotalDebited: 0,
    TotalCreated: 0,
    availableBalance: "",
  });
  const [fixedData, setFixeddData] = useState({
    expenseDescritions: [],
    expenses: [],
    TotalDebited: 0,
    TotalCreated: 0,
    availableBalance: "",
  });
  const [showDateFilter, setShowDateFilter] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState("All");

  const [selectedExpenseType, setSelectedExpenseType] = useState("");
  const [defaultDescription, setDefaultDescription] = useState("");
  const [defaultType, setDefaultType] = useState(); // Set the default type to 'Credited'
  const [amount, setAmount] = useState("");
  const [subUserId, setuserid] = useState("");
  const [editExpenseId, setEditExpenseId] = useState(null);


  const currentDate = new Date();
  const firstDayOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1
  );
  const lastDayOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() + 1,
    0
  );
  const [SelectDate, setSelectedDate] = useState(currentDate);
  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState("All");

  // user from local storage
  const storedUserData = localStorage.getItem("userData");
  let userId = "";
  let groupId = "";
  let userTypeId = "";
  let userStoreName = "";
  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    userId = userData.userId;
    groupId = userData.groupId;
    userTypeId = userData.userTypeId;
    userStoreName = userData.userName;
  }

  const [isOpen, setIsOpen] = useState(false);
  const [userData, setUserData] = useState(null);

  // util: sort by date desc
  const sortByDateDesc = (list = []) => {
    return [...list].sort((a, b) => new Date(b.date) - new Date(a.date));
  };

  // Check localstorage null or not -> redirect if not
  useEffect(() => {
    if (!localStorage.getItem("userData")) {
      history.push("/login");
    }
  }, [history]);

  // fetch user data
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        const res = await fetch(`${BASE_URL}/api/Users/GetUserById?userId=${userId}`);
        if (!res.ok) throw new Error("Network response was not ok");
        const data = await res.json();
        if (!cancelled) {
          setUserData(data);
        }
      } catch (err) {
        console.error("Error fetching user data:", err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [userId]);

  const handleDropdownToggle = () => setIsOpen((s) => !s);

  const handleOptionClick = (action) => {
    setIsOpen(false);
    if (action === "download") {
      handleDownloadPDF();
    } else if (action === "email") {
      handleEmailExpenseReport();
    }
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      window.addEventListener("click", handleClickOutside);
    } else {
      window.removeEventListener("click", handleClickOutside);
    }
    return () => window.removeEventListener("click", handleClickOutside);
  }, [isOpen]);

  // fetch currency
  useEffect(() => {
    let cancelled = false;
    const fetchCurrencyData = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `${BASE_URL}/api/Users/GetCurrencyByUserId?groupId=${groupId}`
        );
        if (!response.ok) throw new Error("Currency API error");
        const data = await response.json();
        if (!cancelled) setCurrency(data.currency || "");
      } catch (error) {
        console.error("Error fetching currency data:", error);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    if (groupId) fetchCurrencyData();
    return () => { cancelled = true; };
  }, [groupId]);

  function formatPayDate(dateString) {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return ` ${day}/${month}/${year}`;
  }

  // fetchData helper: optional setAsFixed param
  const fetchData = useCallback(async (startDateParam = null, endDateParam = null, setAsFixed = false) => {
    try {
      setLoading(true);
      const formattedStartDate = startDateParam
        ? startDateParam.toLocaleDateString("en-CA").replace(/-/g, "/")
        : null;
      const formattedEndDate = endDateParam
        ? endDateParam.toLocaleDateString("en-CA").replace(/-/g, "/")
        : null;

      const apiUrl =
        startDateParam && endDateParam
          ? `${BASE_URL}/api/Expense/GetExpensebyUserId?orderId=${groupId}&userId=${userId}&startDate=${formattedStartDate}&endDate=${formattedEndDate}`
          : `${BASE_URL}/api/Expense/GetExpensebyUserId?orderId=${groupId}&userId=${userId}`;

      const response = await fetch(apiUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();

      // Ensure expenses are sorted and other properties preserved
      const normalized = {
        ...data,
        expenses: data.expenses || [],
        expenseDescritions: data.expenseDescritions || [],
        TotalDebited: data.TotalDebited ?? 0,
        TotalCreated: data.TotalCreated ?? 0,
        availableBalance: data.availableBalance ?? "",
      };

      if (setAsFixed) {
        setFixeddData(normalized);
        setExpenseData(normalized);
      } else {
        // if caller only requested a partial fetch, put it into expenseData
        setExpenseData(normalized);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  }, [groupId, userId]);

  // On mount -> fetch current year (1 Jan -> today) and set fixedData (frontend source of truth)
  useEffect(() => {
    const now = new Date();
    const firstDayOfYear = new Date(now.getFullYear(), 0, 1);
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    setStartDate(firstDayOfYear);
    setEndDate(today);
    setSelectedYear(now.getFullYear().toString());
    setSelectedMonth("All");
    setMonthName(now.toLocaleDateString(undefined, { month: "long" }));

    // fetch and mark as fixed dataset (source for all frontend filters)
    fetchData(firstDayOfYear, today, true);
  }, [fetchData]);

  // fetch available years (original endpoint)
  useEffect(() => {
    let cancelled = false;
    const fetchYears = async () => {
      try {
        const res = await fetch(
          `https://dashboards.workanthem.com/api/available-years?groupId=${groupId}`
        );
        if (!res.ok) throw new Error("Years API error");
        const data = await res.json();
        const sortedYears = (data.years || []).sort((a, b) => b - a);
        if (!cancelled) setYears(sortedYears);
      } catch (error) {
        console.error("Error fetching years:", error);
      }
    };
    if (groupId) fetchYears();
    return () => { cancelled = true; };
  }, [groupId]);

  // FRONTEND FILTER: apply filters to fixedData.expenses and update expenseData
  const applyFrontendFilter = useCallback(() => {
    const source = (fixedData && fixedData.expenses) ? fixedData.expenses : [];
    if (!source) {
      setExpenseData((prev) => ({ ...prev, expenses: [] }));
      return;
    }

    let filtered = [...source];

    // Year filter
    if (selectedYear !== "All") {
      filtered = filtered.filter((item) => {
        const dt = new Date(item.date);
        return dt.getFullYear().toString() === selectedYear;
      });
    }

    // Month filter
    if (selectedMonth !== "All") {
      filtered = filtered.filter((item) => {
        const dt = new Date(item.date);
        // months stored as 1..12 in UI
        return (dt.getMonth() + 1).toString() === selectedMonth;
      });
    }

    // Checkbox or other filters can be added here (isChecked etc.)
    // If you had a date range picker (startDate/endDate override) you can also filter using startDate/endDate
    if (startDate && endDate) {
      // ensure date range filtering respects the current startDate/endDate (if you want)
      filtered = filtered.filter((item) => {
        const dt = new Date(item.date);
        return dt >= new Date(startDate).setHours(0, 0, 0, 0) && dt <= new Date(endDate).setHours(23, 59, 59, 999);
      });
    }

    // always sort by date desc before setting
    const normalized = {
      ...fixedData,
      expenses: filtered,
    };

    setExpenseData(normalized);
  }, [fixedData, selectedYear, selectedMonth, startDate, endDate]);

  // run frontend filter whenever selection changes or fixedData updates
  useEffect(() => {
    applyFrontendFilter();
  }, [applyFrontendFilter]);

  // Handlers: only change selected states (no new API calls)
  const handleYearChange = async (e) => {
    const y = e.target.value;
    setSelectedYear(y);
    setIsChecked(false);

    if (y === "All") {
      // fetch all years: no start/end date filter
      await fetchData(null, null, true);
      setStartDate(null);
      setEndDate(null);
    } else {
      // fetch selected year only
      const firstDay = new Date(y, 0, 1);
      const lastDay = new Date(y, 11, 31);
      setStartDate(firstDay);
      setEndDate(lastDay);
      await fetchData(firstDay, lastDay, true);
    }
  };

  const handleMonthChange = (e) => {
    const m = e.target.value;
    setSelectedMonth(m);
    setIsChecked(false);
    // Frontend filter effect will run
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedExpenseType || !SelectDate || !amount) {
      Swal.fire({
        icon: "error",
        title: "Something went wrong",
        text: "All fields are required!",
      });
      return;
    }

    const formData = {
      expenseId: editExpenseId || 0,
      userId: editExpenseId > 0 ? subUserId : userId,
      expenseDescType: selectedExpenseType,
      description: defaultDescription,
      expenses: amount,
      expenseTypeId: defaultType.toString(),
      Date: SelectDate,
    };

    try {
      setLoading(true);

      const response = await fetch(`${BASE_URL}/api/Expense/AddExpense`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      // ✅ RE-FETCH BASED ON CURRENT FILTER STATE
      let fromDate = null;
      let toDate = null;

      if (selectedYear !== "All") {
        fromDate = new Date(selectedYear, 0, 1);
        toDate = new Date(selectedYear, 11, 31);
      } else if (startDate && endDate) {
        fromDate = startDate;
        toDate = endDate;
      } else {
        const now = new Date();
        fromDate = new Date(now.getFullYear(), 0, 1);
        toDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      }

      await fetchData(fromDate, toDate, true);

      Swal.fire({
        icon: "success",
        title: "Success!",
        text: editExpenseId
          ? "Expense updated successfully!"
          : "Expense added successfully!",
      });

      // reset form
      setSelectedExpenseType("");
      setDefaultDescription("");
      setDefaultType("");
      setAmount("");
      setSelectedDate(new Date());
      setEditExpenseId(null);

    } catch (error) {
      console.error("Error adding/updating expense:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while processing the expense.",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = async (expenseId) => {
    try {
      const response = await fetch(
        `${BASE_URL}/api/Expense/GetExpensebyUserIdandExpenseId?expenseId=${expenseId}&userId=${userId}&userTypeId=${userTypeId}`
      );

      if (!response.ok) {
        const errorMessage = await response.text();
        throw new Error(
          `HTTP error! Status: ${response.status}, Message: ${errorMessage}`
        );
      }

      const editExpenseData = await response.json();
      const dateStr = editExpenseData.date;
      const dateOnly = dateStr.split("T")[0];
      // Update the form fields with the fetched data
      setSelectedExpenseType(editExpenseData.expenseDescType);
      setDefaultDescription(editExpenseData.description);
      setAmount(editExpenseData.expenses);
      setDefaultType(editExpenseData.expenseTypeId);
      setSelectedDate(dateOnly);
      setuserid(editExpenseData.userId);
      // Set the editExpenseId state to track the currently edited expense
      setEditExpenseId(expenseId);
    } catch (error) {
      console.error("Error fetching edit expense data:", error);

      // Check if the error message indicates "You can not update this data"
      if (error.message.includes("You can not update this transaction")) {
        // Display a user-friendly error message
        Swal.fire({
          icon: "error",
          title: "Sorry!",
          text: "You cannot update this transaction.",
        });
      } else {
        // Display a generic error message
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "An error occurred while fetching the edit expense data. Please try again later.",
        });
      }
    }
  };

  // Delete handler: keep API call but re-fetch current-year after deletion
  const handleDelete = async (expenseId) => {
    const result = await Swal.fire({
      title: "Delete Confirmation",
      text: "Are you sure to delete this Transaction?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    });
    if (!result.isConfirmed) return;

    try {
      setLoading(true);
      const response = await fetch(
        `${BASE_URL}/api/Expense/DeleteExpensebyExpenseId?expenseId=${expenseId}&userId=${userId}&userTypeId=${userTypeId}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        }
      );
      if (!response.ok) {
        const errorMessage = await response.text();
        throw new Error(`HTTP error! Status: ${response.status}, Message: ${errorMessage}`);
      }

      // Re-fetch current year as fixed dataset (so frontend filters remain accurate)
      const now = new Date();
      const firstDayOfYear = new Date(now.getFullYear(), 0, 1);
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      await fetchData(firstDayOfYear, today, true);

      Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: "The Transaction has been deleted successfully.",
      });
    } catch (error) {
      console.error("Error deleting expense:", error);
      if (error.message.includes("You can not Delete this transaction")) {
        Swal.fire({ icon: "error", title: "Sorry!", text: "You can not Delete this transaction." });
      } else {
        Swal.fire({ icon: "error", title: "Error", text: "An error occurred while deleting the expense. Please try again later." });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadPDF = () => {
    setLoading(true);
    try {
      const doc = new jsPDF();
      doc.setFontSize(16);
      doc.text(`Expenses Report (${currency})`, 14, 22);

      const tableColumn = ["Date", "Description", "Category", "Type", "Amount"];
      const tableRows = [];

      (expenseData.expenses || []).forEach((expense) => {
        const date = formatPayDate(expense.date).trim();
        const type = expense.expenseTypeId === "Cr." ? "Credit" : "Debit";
        const amountValue = parseFloat(expense.expenses || 0).toLocaleString();
        const signedAmount = `${type === "Credit" ? "+" : "-"}${amountValue}`; // currency removed
        tableRows.push([date, expense.description, expense.expenseDescType, type, signedAmount]);
      });

      autoTable(doc, {
        head: [tableColumn],
        body: tableRows,
        startY: 30,
        styles: { fontSize: 9 },
        columnStyles: { 0: { cellWidth: 28 }, 1: { cellWidth: 50 }, 2: { cellWidth: 30 }, 3: { cellWidth: 25 }, 4: { cellWidth: 35 } },
      });

      doc.save("Expense Report.pdf");
    } catch (error) {
      console.error("Error generating PDF:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while generating the PDF. Please try again later."
      });
    } finally {
      setLoading(false);
    }
  };

  const handleEmailExpenseReport = async () => {
    // show Swal input for email
    const { value: email } = await Swal.fire({
      title: "Send Expense Report via Email",
      html: `
      <p>Enter the email to send your filtered expense report:</p>
       <input 
    type="email" 
    id="swal-input1" 
    class="swal2-input" 
    value="${userData?.emailId || ''}" 
    style="width: 250px;"
  >`,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Send",
      preConfirm: () => {
        const inputEmail = document.getElementById("swal-input1").value;
        if (!inputEmail || !/\S+@\S+\.\S+/.test(inputEmail)) {
          Swal.showValidationMessage("Please enter a valid email");
          return false;
        }
        return inputEmail;
      },
    });

    if (!email) return; // user cancelled or invalid

    setLoading(true);
    try {
      const cleanedExpenses = (expenseData?.expenses || []).map((exp) => ({
        ExpenseId: exp.expenseId || exp.ExpenseId,
        Description: exp.description || exp.Description,
        ExpenseTypeId: exp.expenseTypeId || exp.ExpenseTypeId,
        ExpenseDescType: exp.expenseDescType || exp.ExpenseDescType, // <-- CATEGORY FIX
        Expenses: exp.expenses || exp.Expenses,
        Date: exp.date || exp.Date,
        Type: exp.expenseTypeId === "Cr." ? "Cr." : "Dr.",
        Balance: exp.Balance,
        CreatedOn: exp.CreatedOn,
        GroupId: exp.GroupId,
        UserId: exp.UserId,
        IsDeleted: exp.IsDeleted,
      }));

      const payload = { email, fullName: userData?.fullName, expenses: cleanedExpenses };
      const response = await fetch("https://dashboards.workanthem.com/api/expenses/send-report", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error(`HTTP Error: ${response.status}`);

      Swal.fire({
        icon: "success",
        title: "Report Sent!",
        text: `Your filtered expense report has been emailed to ${payload.email}`,
      });
    } catch (error) {
      console.error("Email Error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while sending your expense report.",
      });
    } finally {
      setLoading(false);
    }
  };

  // Check if availableBalance is greater than 0
  const isPositiveBalance = parseFloat(fixedData.availableBalance || 0) > 0;
  const balanceColor = isPositiveBalance ? "rgb(0, 0, 255)" : "red";

  const sortedExpenseTypes = (expenseData.expenseDescritions || []).slice().sort((a, b) => a.expenseTypeName.localeCompare(b.expenseTypeName));

  function formatDateToDDMMYYYY(dateString) {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" });
  }

  // Edit handler (navigate)
  // const handleEdit = (expenseId) => {
  //   history.push(`/expenses/${expenseId}`);
  // };

  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
    }}>
      <Navbar />

      <div className="cust-div" style={{
        flex: 1,
      }}>
        <BlockUiOverlay visible={loading} />

        <div className="container-fluid mx-auto custom-padding">

          <div className="flex flex-wrap items-center justify-between mb-1 p-0.5">

            {/* Left Side */}
            <div className="flex flex-wrap items-center">
              <h1 className="text-2xl pr-4 font-bold">Expenses ({currency})</h1>

              <div className="flex flex-wrap ml-4 text-sm lg:text-base">
                <span className="mr-4">
                  <strong>Available Balance:</strong>{" "}
                  <span className="font-semibold" style={{ color: balanceColor }}>
                    {fixedData.availableBalance}
                  </span>{" "}
                  |
                </span>

                <span className="mr-4">
                  <strong>Total Credited:</strong>{" "}
                  <span className="text-green-500 font-semibold">
                    {fixedData.totalCreated}
                  </span>{" "}
                  |
                </span>

                <span className="mr-4">
                  <strong>Total Debited:</strong>{" "}
                  <span className="text-red-500 font-semibold">
                    {fixedData.totalDebited}
                  </span>
                </span>
              </div>
            </div>

            {/* Right Side Button */}
            <Link
              to="/expenseDashboard"
              className="flex items-center text-lg text-lightBlue-500 hover:text-lightBlue-700 gap-2 px-3 py-2 rounded-lg transition"
              style={{ textDecoration: "none" }}
            >
              <MoveLeft size={20} />
              Go to Dashboard
            </Link>

          </div>

          {/* ---------------- TOP FILTER AREA ---------------- */}
          <div className="flex flex-col lg:flex-row justify-between items-center mb-4 gap-3">

            {/* LEFT side – date info */}
            <div>
              {startDate && endDate ? (
                <div className="flex flex-wrap items-center text-sm lg:text-base font-medium">
                  <span className="mr-4 font-semibold">
                    From {formatDateToDDMMYYYY(startDate)} to{" "}
                    {formatDateToDDMMYYYY(endDate)}
                  </span>

                  <span className="mr-4">
                    <MoveRight />
                  </span>

                  <span className="mr-4">
                    <strong>Credited:</strong>{" "}
                    <span className="text-green-500">{expenseData.totalCreated}</span> |
                  </span>

                  <span className="mr-4">
                    <strong>Debited:</strong>{" "}
                    <span className="text-red-500">{expenseData.totalDebited}</span>
                  </span>
                </div>
              ) : (
                <div className="flex flex-wrap items-center text-sm lg:text-base font-medium">
                  <span className="mr-4 font-bold">All Transactions</span>

                  <span className="mr-4">
                    <strong>Credited:</strong>{" "}
                    <span className="text-green-500">{expenseData.totalCreated}</span> |
                  </span>

                  <span className="mr-4">
                    <strong>Debited:</strong>{" "}
                    <span className="text-red-500">{expenseData.totalDebited}</span>
                  </span>
                </div>
              )}
            </div>

            {/* RIGHT side – Report dropdown + Add Expense */}
            <div className="flex items-center gap-2">

              {/* Report Dropdown */}
              <div className="relative" ref={dropdownRef}>

                {/* Button (unchanged) */}
                <button
                  className="bg-lightBlue-500 text-white px-2 py-2 rounded shadow-sm flex items-center gap-1 hover:bg-lightBlue-600 transition whitespace-nowrap"
                  onClick={handleDropdownToggle} style={{ fontSize: "13px" }}
                >
                  Expense Report
                  {isOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                </button>

                {/* Dropdown */}
                {isOpen && (
                  <div className="absolute right-0 md:right-0 left-0 md:left-auto mt-2 w-48 md:w-56 bg-white rounded-md shadow-lg z-40">

                    <button
                      onClick={() => handleOptionClick("download")}
                      className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100"
                      style={{ fontSize: "13px" }}
                    >
                      Download Expense Report
                    </button>

                    <button
                      onClick={() => handleOptionClick("email")}
                      className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100"
                      style={{ fontSize: "13px" }}
                    >
                      Email Expense Report
                    </button>

                  </div>
                )}
              </div>

              {!showDateFilter && (
                <>
                  {/* Year Dropdown */}
                  <div className="relative" style={{ width: "100px" }}>
                    <select
                      value={selectedYear}
                      onChange={handleYearChange}
                      className="w-full px-3 py-2 appearance-none pr-8"
                      style={{ border: "1px solid #ddd", borderRadius: '5px' }}

                    >
                      <option value="All">All Years</option>
                      {years.map((year) => (
                        <option value={year} key={year}>{year}</option>
                      ))}
                    </select>
                  </div>

                  {/* Month Dropdown */}
                  <div className="relative flex" style={{ width: "120px" }}>
                    <select
                      value={selectedMonth}
                      onChange={handleMonthChange}
                      className="w-full px-3 py-2 appearance-none pr-8"
                      style={{ border: "1px solid #ddd", borderRadius: '5px' }}

                    >
                      <option value="All">All Months</option>
                      {[
                        "January", "February", "March", "April", "May", "June",
                        "July", "August", "September", "October", "November", "December"
                      ].map((m, i) => (
                        <option value={i + 1} key={i + 1}>{m}</option>
                      ))}
                    </select>
                  </div>
                </>
              )}

              {/* Date Picker */}
              {showDateFilter && (
                <DateRangePicker
                  value={startDate && endDate ? [startDate, endDate] : null}
                  onChange={(v) => {
                    if (!v) {
                      setStartDate(firstDayOfMonth);
                      setEndDate(lastDayOfMonth);
                      setSelectedYear(currentDate.getFullYear().toString());
                      setSelectedMonth((currentDate.getMonth() + 1).toString());
                      fetchData(firstDayOfMonth, lastDayOfMonth);
                      setShowDateFilter(false);
                    } else {
                      setStartDate(v[0]);
                      setEndDate(v[1]);
                      setSelectedYear("All");
                      setSelectedMonth("All");
                      fetchData(v[0], v[1]);
                    }
                  }}
                  className="w-[240px]"
                  format="dd/MM/yy"
                  showOneCalendar
                  character=" – "
                />
              )}

              {/* Filter Toggle Button */}
              <button
                onClick={() => setShowDateFilter(!showDateFilter)}
                className="p-2 rounded hover:bg-gray-100 transition"
              >
                <SlidersHorizontal size={24} />
              </button>

              {/* Add Expense */}
              {/* <button
                className="transition flex gap-2 items-center px-3 py-2 rounded font-medium shadow bg-green-500 text-white"
                onClick={() => history.push("/expenses/add-expense")}
              >
                <Plus size={18} /> Add Expense
              </button> */}
            </div>
          </div>

          {/* ---------------- FILTER ROW (Year / Month / Date) ---------------- */}


          <div className="w-full px-2 md:px-0">
            <form onSubmit={handleSubmit}>
              <div className="flex flex-col md:flex-row md:flex-nowrap w-full items-stretch gap-3">

                {/* Expense Type */}
                <select
                  className="custom-height w-full md:w-[180px]"
                  id="ExpenseDesctype"
                  ref={userNameInputRef}
                  onChange={(e) => {
                    const selectedType = e.target.value;
                    setSelectedExpenseType(selectedType);

                    const selectedTypeData =
                      expenseData.expenseDescritions.find(
                        (type) => type.expenseTypeName === selectedType
                      );

                    if (selectedTypeData) {
                      setDefaultDescription(selectedTypeData.defaulttext);
                      setDefaultType(selectedTypeData.expenseTypeId);
                    }

                    if (selectedType === "__addNewExpense__") {
                      history.push("/addexpensetype");
                    }
                  }}
                  value={selectedExpenseType}
                >
                  <option value="">Select Expense Type</option>

                  {sortedExpenseTypes.map((expenseDesc) => (
                    <option key={expenseDesc.id} value={expenseDesc.expenseTypeName}>
                      {expenseDesc.expenseTypeName}
                    </option>
                  ))}

                  {userTypeId != 3 && (
                    <option
                      value="__addNewExpense__"
                      style={{
                        background: "green",
                        color: "white",
                        fontWeight: "bold",
                      }}
                    >
                      + Add New Expense Type
                    </option>
                  )}
                </select>

                {/* Description */}
                <input
                  type="text"
                  className="form-control custom-height w-full md:w-[250px]"
                  placeholder="Description"
                  maxLength={150}
                  id="Description"
                  value={defaultDescription}
                  onChange={(e) => setDefaultDescription(e.target.value)}
                />

                {/* Amount */}
                <input
                  type="text"
                  className="form-control custom-height w-full md:w-[200px]"
                  placeholder={`Amount (${currency})`}
                  id="Expense"
                  maxLength={7}
                  value={amount}
                  onChange={(e) => {
                    const numericValue = e.target.value.replace(/[^0-9]/g, "");
                    setAmount(numericValue);
                  }}
                />

                {/* Mobile: Credit + Date in one row */}
                <div className="flex w-full gap-2 md:w-auto md:gap-3">

                  <select
                    className="custom-height w-1/2 md:w-[150px]"
                    id="Type"
                    value={defaultType}
                    onChange={(e) => setDefaultType(e.target.value)}
                  >
                    <option value="1">Credited</option>
                    <option value="2">Debited</option>
                  </select>

                  <DatePicker
                    selected={new Date(SelectDate)}
                    onChange={(date) => setSelectedDate(date)}
                    className="form-control custom-height w-1/2 md:w-[180px]"
                    dateFormat="dd/MM/yyyy"
                    maxDate={currentDate}
                  />
                </div>

                {/* Button */}
                <button
                  className="w-full md:w-auto text-white bg-blue-500 text-xs font-bold uppercase shadow hover:shadow-lg transition-all duration-150 custom-button"
                  type="submit"
                  style={{ height: "35px", minWidth: "150px" }}
                  title={editExpenseId ? "Update Expense" : "Add New Expense"}
                >
                  {editExpenseId ? "Update" : "Add"}
                </button>
              </div>
            </form>
          </div>

          {/* ---------------- TABLE ---------------- */}
          <div className="overflow-x-auto mt-6">
            <table className="w-full min-w-full border rounded-lg overflow-hidden shadow-sm">
              <thead>
                <tr className="bg-lightBlue-500 text-white">
                  <th className="py-3 px-4 text-left font-semibold">Type</th>
                  <th className="py-3 px-4 text-left font-semibold">Description</th>
                  <th className="py-3 px-4 text-left font-semibold">Amount ({currency})</th>
                  <th className="py-3 px-4 text-left font-semibold">Date</th>
                  <th className="py-3 px-4 text-left font-semibold">Balance</th>
                  <th className="py-3 px-4 text-left font-semibold">Added By</th>
                  <th className="py-3 px-4 text-right font-semibold">Actions</th>
                </tr>
              </thead>

              <tbody>
                {expenseData?.expenses?.length > 0 ? (
                  expenseData.expenses.map((exp) => (
                    <tr
                      key={exp.expenseId}
                      className="border-b border-white hover:bg-gray-50 transition"
                      style={{
                        backgroundColor:
                          exp.expenseTypeId === "Cr." ? "#D5F5E3 "
                            : "#FADBD8",
                      }}
                    >
                      <td className="py-2 px-4">
                        {exp.expenseTypeId === "Cr." ? (
                          <i className="fas fa-arrow-up text-green-500 mr-1"></i>
                        ) : (
                          <i className="fas fa-arrow-down text-orange-500 mr-1"></i>
                        )}
                        {exp.expenseDescType}
                      </td>

                      <td className="py-2 px-4" title={exp.description}>
                        {exp.description.length > 80
                          ? exp.description.substring(0, 80) + "..."
                          : exp.description}
                      </td>

                      <td className="py-2 px-4">{exp.expenses}</td>
                      <td className="py-2 px-4">{formatPayDate(exp.date)}</td>
                      <td className="py-2 px-4">{exp.balance}</td>
                      <td className="py-2 px-4">{exp.userName}</td>

                      <td className="py-2 px-4 gap-2">
                        <button
                          onClick={() => handleEdit(exp.expenseId)}
                          className="rounded hover:bg-blue-100 text-blue-500 transition"
                          style={{ paddingRight: "10px" }}
                          title="Edit"
                        >
                          <Pencil size={20} />
                        </button>
                        <button
                          onClick={() => handleDelete(exp.expenseId)}
                          className=" rounded hover:bg-red-100 text-red-500 transition"
                          title="Delete"
                        >
                          <Trash2 size={20} />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="7"
                      className="text-center py-6 text-gray-600 text-lg"
                    >
                      No expenses recorded.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

        </div>
      </div>
      <ExpenseChatbot />
      <Footer />
    </ div>
  );
};
export default Expense;